import React, { useEffect, useState, useContext } from "react";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import Editor from "../../../Pages/Editor/Editor";
import "./SampleContentModal.scss";

function SampleItem({
  resumedata,
  index,
  randomTemplate,
  full,
  job_title,
  job_title1,
  isChangeLayoutNeedSample,
}) {
  const {
    json,
    setJson,
    jsonIndex,
    setJsonIndex,
    isJson,
    setIsJson,
    isSample,
    setIsSample,
  } = useContext(jsonEditorContext);
  //Json Handle
  let dateRange0 = {
    fromYear: 2018,
    fromMonth: "Mar",
    toYear: null,
    toMonth: null,
    isOnGoing: true,
    onGoingText: "Ongoing",
  };
  let dateRange1 = {
    fromYear: 2016,
    fromMonth: "Jan",
    toYear: 2018,
    toMonth: "Feb",
    isOnGoing: false,
    onGoingText: "Ongoing",
  };
  useEffect(() => {
    let data = JSON.parse(resumedata);
    if (data && data.profile && data.profile.data && data.profile.data[0]) {
      data.profile.data[0].jobTitle = job_title;
    }
    if (
      data &&
      data.experience &&
      data.experience.data &&
      data.experience.data[0]
    ) {
      data.experience.data[0].dateRange = dateRange1;
    }
    if (
      data &&
      data.experience &&
      data.experience.data &&
      data.experience.data[1]
    ) {
      data.experience.data[1].dateRange = dateRange1;
    }

    if (
      data &&
      data.education &&
      data.education.data &&
      data.education.data[0]
    ) {
      data.education.data[0].dateRange = dateRange0;
    }
    if (
      data &&
      data.education &&
      data.education.data &&
      data.education.data[1]
    ) {
      data.education.data[1].dateRange = dateRange1;
    }

    if (isChangeLayoutNeedSample) {
      // add missing sections
      const current_sectionPosition = data.sectionPosition;
      const current_layout = data.layout;
      let anotherSectionPosition =
        randomTemplate &&
        randomTemplate.settings &&
        randomTemplate.settings.sectionPosition;
      let anotherLayout =
        randomTemplate &&
        randomTemplate.settings &&
        randomTemplate.settings.layout;

      const combinedLsbarRsbar = [
        ...anotherSectionPosition.lsbar,
        ...anotherSectionPosition.rsbar,
      ]; // Combine lsbar and rsbar of anotherSectionPosition

      // Find missing sections for currentSection.lsbar and currentSection.rsbar
      const missingLsbar = current_sectionPosition.lsbar.filter(
        (section) => !combinedLsbarRsbar.includes(section)
      );
      const missingRsbar = current_sectionPosition.rsbar.filter(
        (section) => !combinedLsbarRsbar.includes(section)
      );

      // Combined array of missing sections (from both lsbar and rsbar)
      const missingSections = [...missingLsbar, ...missingRsbar];

      console.log("Missing Sections:", missingSections);

      // Step 2: Update or push new sections in anotherLayout
      missingSections.forEach((section) => {
        let sectionFound = false;
        console.log(section, "section");

        // Check if the section exists in currentLayout
        current_layout.forEach((layout, index) => {
          layout.forEach((item) => {
            if (item.section === section) {
              sectionFound = true;

              // Check if the section exists in the anotherLayout and update itemIndexes
              anotherLayout[index].forEach((anotherItem) => {
                if (anotherItem.section === section) {
                  anotherItem.itemIndexes = [
                    ...new Set([
                      ...anotherItem.itemIndexes,
                      ...item.itemIndexes,
                    ]),
                  ];
                }
              });

              // If the section isn't found in the anotherLayout, push it
              if (
                !anotherLayout[index].some((item) => item.section === section)
              ) {
                anotherLayout[index].push({
                  page: 0,
                  height: item.height, // Assuming height from currentLayout
                  section: section,
                  itemIndexes: item.itemIndexes,
                });
              }
            }
          });
        });

        if (
          data &&
          data.customization &&
          data.customization.grid_width &&
          data.customization.grid_width > 500
        ) {
          anotherSectionPosition.rsbar.push(section);
        } else {
          anotherSectionPosition.lsbar.push(section);
        }

        // If section not found in currentLayout, create a new layout entry
        if (!sectionFound) {
          if (
            data &&
            data.customization &&
            data.customization.grid_width &&
            data.customization.grid_width > 500
          ) {
            anotherLayout[1].push({
              page: 0,
              height: 120, // Default height or suitable value can be assigned
              section: section,
              itemIndexes: [0], // Assuming default itemIndex
            });
          } else {
            anotherLayout[0].push({
              page: 0,
              height: 120, // Default height or suitable value can be assigned
              section: section,
              itemIndexes: [0], // Assuming default itemIndex
            });
          }
        }
      });

      console.log(anotherLayout, "anotherLayout");
      console.log(anotherSectionPosition, "anotherSectionPosition");

      //below code added from common to if only.if code doesnt work remove from if and make it common

      data.layout =
        randomTemplate &&
        randomTemplate.settings &&
        randomTemplate.settings.layout;
      data.sectionPosition =
        randomTemplate &&
        randomTemplate.settings &&
        randomTemplate.settings.sectionPosition;
      data.customization =
        randomTemplate &&
        randomTemplate.settings &&
        randomTemplate.settings.customization;
      data.editorSettings =
        randomTemplate &&
        randomTemplate.settings &&
        randomTemplate.settings.editorSettings;
      data.template_id = randomTemplate && randomTemplate.template_code;
    } else {
      //   data.layout =
      //   randomTemplate &&
      //   randomTemplate.settings &&
      //   randomTemplate.settings.layout;
      // data.sectionPosition =
      //   randomTemplate &&
      //   randomTemplate.settings &&
      //   randomTemplate.settings.sectionPosition;
      // data.customization =
      //   randomTemplate &&
      //   randomTemplate.settings &&
      //   randomTemplate.settings.customization;
      // data.editorSettings =
      //   randomTemplate &&
      //   randomTemplate.settings &&
      //   randomTemplate.settings.editorSettings;
      data.template_id = randomTemplate && randomTemplate.template_code;
    }

    console.log(data, "dataaaa");
    setJson(data);
    setJsonIndex(index);
    setIsJson(true);
    setIsSample(true);
  }, [resumedata, index]);

  return (
    <div className="sample_img_modal  w-100">
      <div
        className="preview_scale"
        style={
          full
            ? { transform: "scale(0.85)", transformOrigin: "0px 0px" }
            : { transform: "scale(0.25)", transformOrigin: "0px 0px" }
        }
      >
        <Editor index={index} sample={true} preview={true} />
      </div>
    </div>
  );
}

export default SampleItem;
